import { createSlice } from "@reduxjs/toolkit";

export const ChalanSlice = createSlice({
    name: "chalanSlice",
    initialState: {
        allChalan: [],
        allChallanWithPagination: {
            total_page_count: 1,
            data: []
        },
        pendingChalan: [],
        allDueChalan: [],
        allDueChalanWithPagination: {
            total_page_count: 1,
            data: []
        }
    }, reducers: {
        getAllChalanReducer: (state, action) => {
            state.allChalan = action.payload
        },
        getAllPendingChalanReducer: (state, action) => {
            state.pendingChalan = action.payload
        },
        getAllDueChalanReducer: (state, action) => {
            state.allDueChalan = action.payload
        },
        getAllChallanWithPaginationReducer: (state, action) => {
            state.allChallanWithPagination = {
                total_page_count: action?.payload?.total_page_count || 1,
                data: action?.payload?.data || []
            }
        },
        getAllDueChallanWithPaginationReducer: (state, action) => {
            state.allDueChalanWithPagination = {
                total_page_count: action?.payload?.total_page_count || 1,
                data: action?.payload?.data || []
            }
        }
    }
})